import { PasswordRecover } from '../_models/index';
import { UserContext } from '../_context/user.context';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGenaralPagination, IOrganisationInfo, ISecurityQuestionsAnswers, ISimpleOrganisation, IUserDetailsRecoveryToken, IUserForgotPassDetails, SecurityPoliciesOfUserForReset } from '../shared/interfaces';

@Injectable()
export class UserService {
  private user: UserContext;
  private idamApiURL: string = environment.idam_api_url;
  private cloudApiURL: string = environment.cloud_api_url;

  constructor(private _http: HttpClient) {
    this.user = new UserContext();
  }

  findPeopleIdentityType(id: string): Observable<HttpResponse<any>> {
    const jwt: any = JSON.parse(localStorage.getItem('currentUser'));
    this.user = jwt.token;
    const url: string = `${this.idamApiURL}/api/v1/people/${id}/identity-type`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.user
    });
    return this._http.get(url, { observe: 'response', headers: headers });
  }

  getPeopleById(id: string): Observable<HttpResponse<any>> {
    const jwt = JSON.parse(localStorage.getItem('currentUser'));
    this.user = jwt.token;
    const url = `${this.idamApiURL}/api/v1/people/${id}`;
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.user
    });
    return this._http.get(url, { observe: 'response', responseType: 'json', headers: headers });
  }

  getHomeUser(peopleId: any): Observable<HttpResponse<any>> {
    const headers = this.getHeader();
    const url = `${this.idamApiURL}/api/v1/people/${peopleId}/users`;
    return this._http.get(url, { observe: 'response', headers: headers });
  }

  getUserByOrganisation(userId: any, organisationId: any): Observable<HttpResponse<any>> {
    const headers = this.getHeader();
    const url = `${this.idamApiURL}/api/v1/organisations/${organisationId}/users/${userId}`;
    return this._http.get(url, { observe: 'response', headers: headers });
  }

  getIdentityTypeById(id: any): Observable<HttpResponse<any>> {
    const headers = this.getHeader();
    const url = `${this.cloudApiURL}/api.cloud.net/v1/identityType/${id}/get`
    return this._http.get(url, { observe: 'response', headers: headers });
  }

  getIdentityById(id: string): Observable<HttpResponse<any>> {
    const headers = this.getHeader();
    const url = `${this.cloudApiURL}/api.cloud.net/v1/identityType/${id}/get`;
    return this._http.get(url, { observe: 'response', headers: headers });
  }

  contextualizeToken(organisationId: string, code: string = null): Observable<HttpResponse<any>> {
    let url: string;
    if (code) {
      url = `${this.idamApiURL}/api/v1/auth/contextualise?organisation=${organisationId}&code=${code}`;
    }
    else {
      url = `${this.idamApiURL}/api/v1/auth/contextualise?organisation=${organisationId}`;
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.user,
      'X-Tenant-ID': 'tenant1'
    });
    return this._http.post(url, null, { observe: 'response', headers: headers });
  }

  checkPeopleLastAccess(id: string): Observable<HttpResponse<any>> {
    const headers = this.getHeader();
    const url: string = `${this.idamApiURL}/api/v1/people/${id}/check`;
    return this._http.patch(url, null, { observe: 'response', headers: headers });
  }

  resetPassword(resetPassword: any, person: string): Observable<HttpResponse<any>> {
    const url: string = `${this.idamApiURL}/api/v1/people/${person}/password`;
    const jwt: any = JSON.parse(localStorage.getItem('currentUser'));
    this.user = jwt.token;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.user,
      'X-Tenant-ID': 'tenant1'
    });
    return this._http.post(url, resetPassword, { observe: 'response', headers: headers });
  }

  checkUsernameAuthentication(username: any): Observable<HttpResponse<any>> {
    const url: string = `${this.idamApiURL}/api/v1/auth/username/login?tenant=tenant1`;
    const usernameObject = { username: username }
    return this._http.post(url, usernameObject, { observe: 'response' });
  }

  checkUsernameAuthenticationWithOrganisation(username: any, organisationId: any): Observable<HttpResponse<any>> {
    const url: string = `${this.idamApiURL}/api/v2/auth/username/login?tenant=tenant1`;
    const usernameObject: any = { username: username, organisationId: organisationId }
    return this._http.post(url, usernameObject, { observe: 'response' });
  }

  forgotPassword(email: any): Observable<HttpResponse<any>> {
    const url: string = `${this.idamApiURL}/api/v1/password-recovery/email?tenant=tenant1`;
    return this._http.post<any>(url, email);
  }

  forgotPasswordChange(passwordRecover: PasswordRecover): Observable<HttpResponse<any>> {
    const url: string = `${this.idamApiURL}/api/v1/password-recovery/token?tenant=tenant1`;
    return this._http.post<any>(url, passwordRecover);
  }

  contactConfiramtion(token: string, tenant: string) {
    const url = `${this.idamApiURL}/api/v1/contact-method-confirmations/emails?tokenId=${token}&tenant=${tenant}`
    return this._http.get(url);
  }

  checkLinkExpire(token: string) {
    const tenant = 'tenant1'; // Static tenant value
    const url = `${this.idamApiURL}/api/v1/password-recovery/token/${token}?tenant=${tenant}`;
    return this._http.get(url);
}


  accountConfiramtion(token: string, tenant: string, userId: string) {
    const url = `${this.idamApiURL}/`
    return this._http.get(url);
  }

  getOrganisationByUniqueUrl(uniqueUrl: string): Observable<HttpResponse<any>> {
      const url = `${this.cloudApiURL}/api.cloud.net/v1/unique-url/${uniqueUrl}/organisations`
      return this._http.get(url, { observe: 'response' });
  }

  getUsersByPersonId(personId: string): Observable<HttpResponse<any>> {
      const headers = this.getHeader();
      const personUsersURL: string = `${this.idamApiURL}/api/v1/people/${personId}/users?sort=isHomeUser`;
      return this._http.get<Array<any>>(personUsersURL, { observe: 'response', headers: headers });
  }

  getUser(organisationId: any, userId: any): Observable<HttpResponse<any>> {
    const headers = this.getHeader();
    const url = `${this.idamApiURL}/api/v1/organisations/${organisationId}/users/${userId}`
    return this._http.get(url, { observe: 'response', headers: headers });
  }

  getSecurityQuestions(userTypeId: any, organisationId: any): Observable<HttpResponse<any>> {
    const headers = this.getHeader();
    const url = `${this.cloudApiURL}/api.cloud.net/v1/organisations/${organisationId}/user-types/${userTypeId}/security-questions`;
    return this._http.get(url, { observe: 'response', headers: headers });
  }

  // Get configured security questions for recovery
  getSecurityQuestionsByEmail(email: any): Observable<HttpResponse<any>> {
    const url = `${this.idamApiURL}/api/v1/security-questions/email?email=${email}&tenant=tenant1`;
    return this._http.get(url, { observe: 'response' })
  }

  // Get configured security questions for recovery
  getSecurityQuestionsByUsername(username: any): Observable<HttpResponse<any>> {
    const url = `${this.idamApiURL}/api/v1/security-questions/username?username=${username}&tenant=tenant1`;
    return this._http.get(url, { observe: 'response' })
  }

  // Get Person Identity Type By Username (noAuth)
  getIdentityTypeByUsername(username: string): Observable<HttpResponse<any>> {
    const url = `${this.idamApiURL}/api/v1/people/noauth/username/${username}/identity-type?tenant=tenant1`;
    return this._http.get(url, { observe: 'response' })
  }

  getSecurityQuestionsAnswers(personId: any): Observable<HttpResponse<any>> {
    const headers = this.getHeader();
    const url = `${this.idamApiURL}/api/v1/people/${personId}/security-answers`;
    return this._http.get(url, { observe: 'response', headers: headers });
  }

  postSecurityQuestions(personId: any, object: any): Observable<HttpResponse<any>> {
    const headers = this.getHeader();
    const url = `${this.idamApiURL}/api/v1/people/${personId}/security-answers`;
    return this._http.post(url, object, { observe: 'response', headers: headers })
  }

  //Username recovery using email address and security answer
  verifySecurityQuestionsViaEmail(dtoObject: any) {
    const url = `${this.idamApiURL}/api/v1/username-recovery/security-questions?tenant=tenant1`;
    return this._http.post(url, dtoObject, { observe: 'response' })
  }

  // Reset password via security questions
  verifySecurityQuestionsViaUsername(dtoObject: ISecurityQuestionsAnswers) {
    const url = `${this.idamApiURL}/api/v1/password-recovery/security-questions?tenant=tenant1`;
    return this._http.post(url, dtoObject, { observe: 'response' })
  }

  getImage(path: any): Observable<HttpResponse<any>> {
    const url = `${this.cloudApiURL}/api.cloud.net/v1/image?imagePath=${path}`;
    return this._http.get(url, { observe: 'response' });
  }

  getUserById(organisationId: string, userId: string): Observable<HttpResponse<any>> {
    const headers = this.getHeader();
    const url = `${this.idamApiURL}/api/v1/organisations/${organisationId}/users/${userId}`;
    return this._http.get(url, { observe: 'response', headers: headers });
  }

  getSmsEnabled(organisationId): Observable<HttpResponse<any>> {
    const url = `${this.cloudApiURL}/api.cloud.net/v1/organisations/${organisationId}/sms2fa`;
    return this._http.get<any>(url, { observe: 'response', headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  public getPasswordPolicyByUserId(organisationId: string, userId: string): Observable<HttpResponse<any>> {
    const url = `${this.cloudApiURL}/api.cloud.net/v1/organisation/${organisationId}/user/${userId}/security-policy/password-recovery`;
    return this._http.get(url, { observe: 'response'});
  }

  getSecurityPolicyByOrganisation = (organisationId: string, username: string): Observable<HttpResponse<IUserForgotPassDetails>> => {
    const url: string = `${this.cloudApiURL}/api.cloud.net/v1/organisation/${organisationId}/security-policy/forgotten-pass/${username}`;
    return this._http.get<any>(url, { observe: 'response'});
  }

  public getUserDetailsAndSecurityPolicy(username: string): Observable<HttpResponse<IUserForgotPassDetails>> {
    const url = `${this.cloudApiURL}/api.cloud.net/v1/security-policy/forgotten-pass/${username}`;
    return this._http.get<IUserForgotPassDetails>(url, { observe: 'response' });
  }

  public getPasswordPolicyByPersonId(personId: string): Observable<HttpResponse<SecurityPoliciesOfUserForReset>> {
    const headers = this.getHeader();
    const url = `${this.cloudApiURL}/api.cloud.net/v1/person/${personId}/security-policy`;
    return this._http.get<SecurityPoliciesOfUserForReset>(url, { observe: 'response', headers: headers });
  }

  public getAllOrganisationsForLogin(queryParam: string, ids: string[] = []): Observable<IGenaralPagination<ISimpleOrganisation>> {
    const url = `${this.cloudApiURL}/api.cloud.net/v1/organisations/login${queryParam}`
    return this._http.post<IGenaralPagination<ISimpleOrganisation>>(url, ids);
  }

  public getUserDetailsFromRecoveryToken(recoveryToken: string): Observable<HttpResponse<IUserDetailsRecoveryToken>> {
    const url: string = `${this.idamApiURL}/api/v1/password-recovery/user-details/token/${recoveryToken}?tenant=tenant1`;
    return this._http.get<any>(url, { observe: 'response'});
  }

  private getHeader(): HttpHeaders {
    const jwt: any = JSON.parse(localStorage.getItem('currentUser'));
    this.user = jwt.token;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.user
    });

    return headers;
  }

}
